import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { RootTypeReducer } from "../reducers/RootTypeReducer";

const RootTypeContext = createContext({
	state: RootTypeReducer.getInitialState(),
	actions: RootTypeReducer.actions,
});

export const useRootTypeContext = () => useContext(RootTypeContext);

export const RootTypeProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: RootTypeReducer.getInitialState(),
		reducers: RootTypeReducer.caseReducers,
	});
	return (
		<RootTypeContext.Provider value={{ state, actions }}>
			{children}
		</RootTypeContext.Provider>
	);
};
